import { Icon } from "@iconify/react/dist/iconify.js";
import Column from "../Grid/Column";
import Container from "../Grid/Container";
import Row from "../Grid/Row";
import { useRef } from "react";

const HeroEstate = ({ hero }: {
    hero: string;
}) => {
    const wrapperRef = useRef<HTMLDivElement>(null);

    const scrollBottom = () => {
        if (wrapperRef.current && typeof window != undefined) {
            window.scrollTo({
                top: wrapperRef.current.getBoundingClientRect().height,
                behavior: "smooth"
            })
        }
    }

    return (
        <section ref={wrapperRef} className="lg:mb-22 mb-14">
            <div className="min-h-[170px]"></div>
            <img srcSet={hero} alt="Zdjęcie hero"/>
            <Container className="lg:block hidden">
                <Row className="justify-between">
                    <Column xl={8}>
                    </Column>
                    <Column xl={4} className="text-right">
                        <button type="button" className="glass-style px-3 py-6 -mt-12 rounded-[60px] 3xl:-mr-5 mr-10" onClick={() => scrollBottom()} title="Zjedź w dół">
                            <Icon icon={`oui:arrow-down`} className="text-primary" width={40} height={40} />
                        </button>
                    </Column>
                </Row>
            </Container>
        </section>
    )
}

export default HeroEstate;